import React from 'react';
import { RoutesConfig } from "../config";

function App() {
  return <RoutesConfig />
}

export default App;
